import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-774a8d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "hover-underline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-text_link_pfeil ml-2",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      href: _ctx.sanitizeUrl(_ctx.faqUrl),
      class: "no-underline",
      target: "_blank",
      rel: "noopener",
      title: _ctx.$t('common.faqLinkTitle')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1),
        _hoisted_4
      ])
    ], 8, _hoisted_1)
  ]))
}